<template>
<div style="position:relative">
  <no-access ref="noaccess" v-show="noaccess"
    :app="$parent"
    tgt="chat"
    >
  </no-access>

<b-tabs v-if="!noaccess">
 </b-tab>
 <b-tab title="Chat">
  <div style="padding:5px;background-color:white;overflow-x:hidden;">
   <b-row v-if="!is_guest">
    <b-col>
       <b-button
          style="width:100%; padding: 0;"
          size="sm" @click='getchats("older")' variant="outline-primary">
          Older Than {{ chat_older_str }}
       </b-button>
     </b-col>
   </b-row>

   <b-row>
     <b-col md="11">
        <div id="chat_history"> </div>
     </b-col>
   </b-row>

   <b-row v-if="!is_guest">
    <b-col>
       <b-button
          style="width:100%; padding: 0;"
          size="sm" @click='getchats()' variant="outline-primary">
          Fewer/Refresh
       </b-button>
     </b-col>
   </b-row>

   <b-row  v-if="chat_show" class="mt-3">
     <b-col>
        <span style="font-size:0.9rem; font-weight:600;"> {{ chat_dname }} </span>
     </b-col>
   </b-row>
   <b-row  v-if="!is_guest && chat_show">
     <b-col>
        <div v-show="eph" id="ephselect"></div>
     </b-col>
   </b-row>
   <b-row  v-if="chat_show" class="mt-1">
     <b-col>
       <div id="chat_recent"> </div>
     </b-col>
   </b-row>
   <b-row  v-if="chat_show" class="mt-1">
     <b-col>
        <span style="font-size:0.9rem; font-weight:600;"> {{ chat_tgt_msg }} </span>
     </b-col>
   </b-row>
   <b-row v-if="mode == 'attach'"
     style="border-top: 1px solid #808080">
     <b-col>
        <upload-image
          v-model="attach_url"
          v-on:changed="attach_ready"
          imgkind="chat_att"
          types="*"
          size=10
          placeholder="No attachment selected"
          btnlab="Upload & Send"
        />
     </b-col>
   </b-row>
   <div v-if="chat_show" style="display:flex; position:relative;">
     <div  v-if="attach_allowed"  
       style="flex: 0 0 20px;">
       <b-button@click="do_attach"
         class="chat_btn_mode chat_btn_mat chat_btn_attach"
         size="sm">
          attachment
       </b-button>
     </div>
     <div v-if="transfer_allowed" 
       style="flex: 0 0 20px;">       
       <b-button @click="do_transfer(this)"
         class="chat_btn_mode chat_btn_transfer"
         size="sm">
          T
       </b-button>
     </div>
     <div v-if="note_allowed" 
       style="flex: 0 0 20px;">       
       <b-button @click="do_note(this)"
         class="chat_btn_mode chat_btn_note"
         size="sm">
          N
       </b-button>
     </div>
     <div style="flex: 1 1 20px;">
       <input-sub v-if="mode != 'transfer'"
         style="padding-left:0.2rem;font-size:0.9rem;"
         ref="chat_input_box"
         v-model="chat_msg"
         v-on:enter='chat_submit'
         v-on:key='chat_msg_keyup'
         :placeholder='mode_placeholder'
       >
       </input-sub>
       <search-transfer v-if="mode == 'transfer'"
         :pastRooms="$parent.pastRooms"
         :add2Past="$parent.add2Past"
         ontop="true"
         v-on:room="transfer_room"
         v-on:search="do_search"
         placeholder="Transfer user to @room"
       >
       </search-transfer>
     </div>
   </div>
  </div>
 </b-tab>
 <b-tab title="Polling" @click="pollClick">
  <div style="padding:5px;background-color:white;">
    <b-button
      variant="primary"
      @click="pollVote"
    >
     Cast Vote(s)
    </b-button>
    <b-table
       striped
       show-empty
       stacked
       :fields="pollQuestFields"
       :items="pollQuests"
    >
      <template v-slot:cell(q)="data"> 
         {{ data.value }}
      </template>
      <template v-slot:cell(a)="data"> 
         <b-form-group :disabled="data.item.disabled">
            <b-form-radio v-model="data.item.selected" :name="data.item.id" value="0"> {{ data.value[0] }} </b-form-radio>
            <b-form-radio v-model="data.item.selected" :name="data.item.id" value="1"> {{ data.value[1] }} </b-form-radio>
            <b-form-radio v-if="data.value[2]" v-model="data.item.selected" :name="data.item.id" value="2"> {{ data.value[2] }} </b-form-radio>
            <b-form-radio v-if="data.value[3]" v-model="data.item.selected" :name="data.item.id" value="3"> {{ data.value[3] }} </b-form-radio>
            <b-form-radio v-if="data.value[4]" v-model="data.item.selected" :name="data.item.id" value="4"> {{ data.value[4] }} </b-form-radio>
         </b-form-group>
      </template>
      
    </b-table>
  </div>
 </b-tab>
</b-tabs>
</div>
</template>

<script>
import { sync } from "vuex-pathify";
import store from "../store";
import vx_api from "../vuemix";
import { format, getUnixTime } from 'date-fns';
import InputSub from "../components/InputSub";
import UploadImage from "../components/UploadImage";
import SearchTransfer from "../components/SearchTransfer";
import NoAccess from "../components/NoAccess";

export default {
  name: "chat",
  data(){
    return {
      chats:[],
      chats_hash: {},
      chats_eph_hash: {},
      chat_colors:{},
      chat_last_dt: null,
      chat_room: null,
      chat_tgt: null,
      chat_tgt_msg: "",
      chat_msg: "",
      chat_show: true,
      chat_disabled: false,
      chat_ctrl: {},
      show_2pres: false,
      show_2all: false,
      chat_recent: [],
      chat_older_str: "",
      chat_filter_ephidx:0,
      chat_dname: "",
      //chat_host_logo: require("../assets/img/Facebook_Live_400x90_centered.png"),
      chat_host_logo: "",
      users:[],

      is_guest: false,
      eph:0,
      eph_mode: "",
      pollQuests: [],
      pollQuestFields: [
        { key: "q", label: "" },
        { key: "a", label: "" },
        { key: "ctrl", label: "" },
      ],
      attach_allowed: true,
      attach_url: "",
      transfer_allowed: false,
      note_allowed: false,
      mode: "msg",
      mode_placeholder: "Your Message",
      tgt_text: "",
      noaccess: false,
    };
  },
  components: { InputSub, UploadImage, SearchTransfer, NoAccess
  },
  watch: {
    $route(to, from) {
      //console.log("watch:" + from.params.uid + " " + to.params.uid);
      this.setup_room(window.vx, to.params.acc, to.params.uid);
    },
  },
  created() {
  },
  mounted() {
    let vue = this;
    vue.setup_room(window.vx, vue.$router.currentRoute.params.acc,
                   vue.$router.currentRoute.params.uid);
    vue.is_guest = vx_is_guest(window.vx);
  },
  methods: {  
    setup_room: function(vx, room_acc, room_name) {
      let vue = this;
      //console.log("SETUP:"+room_acc+" "+room_name);
      vue.chat_tgt = null;
      vue.chat_recent = [];
      vue.chat_ctrl = {};
      vue.show_2pres = false;
      vue.show_2all = false;
      vue.mode = "msg";
      vue.users = [];
      vue.chat_host_logo = "";
      if (!room_acc || !room_name) {
        vue.chat_room = "";
        vue.chat_disabled = true;
        vue.chat_show = false;
        vue.chat_filter_ephidx = 0;
      } else {
        vue.chat_room = "";
        window.vx_set_room(vx, room_acc, room_name, "chat");
        vue.chat_dname = "@"+vx.room.main_room;
        vue.chat_show = true;
        vue.chat_filter_ephidx = vx.room.ephidx;
        vue.eph_mode = "";
        vxslog({p:"chat",a:"open"});
      }
      window.wss_open(vx, {
        acc: vx.room.acc,
        room: vue.chat_show && vx.room.name,
        uid: vx.user.id,
        cred: vx.user.creds["me"],
        routes_id: "chat",
        routes: {
          auth_me: function() {
            if (vue.chat_show) {
              if (is_my_room(vx)) {
                wss_send(vx, "auth_room", {"tgt":"chat","cred":vx.user.creds["myroom"]});
              } else {
                wss_send(vx, "auth_room", {"tgt":"chat"});
              }
            } else {
            //  vue.getchats();
            }
          },
          auth_room: function() {
            wss_send(vx, "list_user", {});
            wss_send(vx, "get_room_ctrl", {});
            wss_send(window.vx, "cfg_remote", {set_conn:{disabled: true}});
            if (vx.guestQuestion) {
              wss_send(vx, "msg_to", {
                msg: vx.guestQuestion,
                to:{ room: false },
              });
              vx.guestQuestion = null;
            }
          },
          list_user: vue.wss_list_user,
          room_ctrl: vue.wss_room_ctrl,
          msg_to: vue.wss_msg_to,
          my_chats: vue.wss_chats,
          poll: vue.wss_poll,
          room: vue.wss_room,
        }
      });
      window.chatCallMethod = vue.chatCallMethod;
      /* Monitors for tile-click, settings in-room click */
      clearInterval(vue.chat_tid);
      vue.chat_tid = window.setInterval(vue.import_tgt, 500);
    },
    import_tgt: function() {
      let vue = this;
      if (!vx.room || !vx.room.name) { return; }
      let tgt = getLocal("vx_chattgt_"+vx.room.name, true);
      eraseLocal("vx_chattgt_"+vx.room.name);
      if (tgt && tgt.uid) {
         if (vue.chat_ctrl.mode == "limited2" && !vx.room.is_mod) {
           return;
         }
         if (tgt.uid != vx.user.id) {
           vue.switch2User(tgt.uid, tgt.dname);
         }
      }
    },
    changeMode(mode) {
      let vue = this;
      let onclass;
      if (vue.chat_disabled) { return; }
      if (mode) {
        vue.mode = mode;
      }
      switch (vue.mode) {
      case "msg":
        if (vue.tgt_text && vue.tgt_text.length) {
          vue.chat_tgt_msg = "Send Message (To "+vue.tgt_text+")";
          vue.mode_placeholder = "Your Message to "+vue.tgt_text;
        } else {
          vue.chat_tgt_msg = "Send Message";
          vue.mode_placeholder = "Your Message";
        }
        break;
      case "attach":
        vue.mode_placeholder = "Optional message for Attachment";
        onclass = "chat_btn_attach";
        if (vue.tgt_text && vue.tgt_text.length) {
          vue.chat_tgt_msg = "Post Attachment (To "+vue.tgt_text+")";
        } else {
          vue.chat_tgt_msg = "Post Attachment";
        }
        break;
      case "transfer":
        vue.mode_placeholder = "n/a";
        onclass = "chat_btn_transfer";
        vue.chat_msg = "";
        if (vue.tgt_text && vue.tgt_text.length) {
          vue.chat_tgt_msg = "Transfer ("+vue.tgt_text+") to another Room";
        } else {
          vue.chat_tgt_msg = "n/a";
        }
        break;
      case "note":
        vue.mode_text = "Add a Note"
        vue.mode_placeholder = "Notation for other Moderators";
        onclass = "chat_btn_note";
        vue.chat_msg = "";
        if (vue.tgt_text && vue.tgt_text.length) {
          vue.chat_tgt_msg = "Add a Note about "+vue.tgt_text;
        } else {
          vue.chat_tgt_msg = "n/a";
        }
        break;
      default: return;
      }
      let c = document.getElementsByClassName("chat_btn_mode");
      for (let i=0; i<c.length; ++i) {
        let el = c[i];
        if (onclass && el.classList.contains(onclass)) {
          el.setAttribute("modeon","true");
        } else {
          el.setAttribute("modeon","false");
        }
      }
    },
    uid2color(uid) {
      let vue = this;
      if (uid == "anon" || uid == "0") {
      } else if (uid == vx.user.id) {
        return ["#808080","rgba(60,60,60,0.2)","#000000"];
      } else if (uid) {
        let rcolor = vue.chat_colors[uid];
        if (!rcolor) {
          //vue.tmpcnt = vue.tmpcnt || 0;
          let r = (Object.keys(vue.chat_colors).length % 10)/10;
          //vue.tmpcnt = (vue.tmpcnt+1)%11;
/*
          if (r < 0.1)      { rcolor = ["#000000","#7B3357","#000000"]; }
          else if (r < 0.2) { rcolor = ["#000000","#207561","#000000"]; }
          else if (r < 0.3) { rcolor = ["#000000","#3a1f5d","#000000"]; }
          else if (r < 0.4) { rcolor = ["#000000","#ca3202","#000000"]; }
          else if (r < 0.5) { rcolor = ["#000000","#872063","#000000"]; }
          else if (r < 0.6) { rcolor = ["#000000","#543864","#000000"]; }
          else if (r < 0.7) { rcolor = ["#000000","#977e10","#000000"]; }
          else if (r < 0.8) { rcolor = ["#000000","#441010","#000000"]; }
          else if (r < 0.9) { rcolor = ["#000000","#bd0230","#000000"]; }
          else { rcolor = ["#000000","#a94d05","#000000"]; }
*/
          if (r < 0.1)      { rcolor = ["#808080","rgba(250,120,200,0.3)","#000000"]; }
          else if (r < 0.2) { rcolor = ["#808080","rgba(60 ,220,190,0.3)","#000000"]; }
          else if (r < 0.3) { rcolor = ["#808080","rgba(170,140,250,0.3)","#000000"]; }
          else if (r < 0.4) { rcolor = ["#808080","rgba(250,160, 50,0.3)","#000000"]; }
          else if (r < 0.5) { rcolor = ["#808080","rgba(250,100,240,0.3)","#000000"]; }
          else if (r < 0.6) { rcolor = ["#808080","rgba(170,110,190,0.3)","#000000"]; }
          else if (r < 0.7) { rcolor = ["#808080","rgba(250,220, 30,0.3)","#000000"]; }
          else if (r < 0.8) { rcolor = ["#808080","rgba(250, 90, 90,0.3)","#000000"]; }
          else if (r < 0.9) { rcolor = ["#808080","rgba(130,250,130,0.3)","#000000"]; }
          else { rcolor = ["#808080","rgba(190,250,230,0.3)","#000000"]; }
          vue.chat_colors[uid] = rcolor;
        }
        return rcolor;
      }
      return [];
    },
    msg2html(m, opt={}) {
      let vue = this;
      let extp = "";
      if (m == "-") {
        return null;
      }
      //console.log("MSG",JSON.stringify(m),JSON.stringify(vue.chat_tgt));

      /* Show chat if
       *  - Message ephidx matches filter
       *  - From moderator in ephidx 0
       *  - 1-to-1 message whose to/from matches that target
       *  - Is a moderator and control message m.y
       */
      if (m.md && m.ephidx === 0) {
        // From moderator in main; always show
      } else if (vx.room.is_mod && m.y) {
        // Is a moderator and this is a control; always show
      } else if (vue.chat_tgt && vue.chat_tgt.uid != "PRESENTER") {
         /* Currently filtering for a specific person */
         if (vue.chat_tgt.uid !== m.x && vue.chat_tgt.uid !== m.f) {
            /* Does not match targeted user */
            return null;
         }
         /* Only show if 1-to-1 (any breakout) OR matching breakout */
         if (!m.x && m.ephidx !== vue.chat_filter_ephidx) {
            return null;
         }
      } else {
         /* Not filtering for a specific person */
         if (m.ephidx !== vue.chat_filter_ephidx) {
           return null;
         }
      }
      vue.chats_eph_hash[m.ephidx] = true;

      if (m.ext) {
        if (m.ext.provider == "facebook") {
          extp = '<span><svg class="nchat_ext" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14222 14222"><circle cx="7111" cy="7112" r="7111" fill="#1977f3"/><path d="M9879 9168l315-2056H8222V5778c0-562 275-1111 1159-1111h897V2917s-814-139-1592-139c-1624 0-2686 984-2686 2767v1567H4194v2056h1806v4969c362 57 733 86 1111 86s749-30 1111-86V9168z" fill="#fff"/></svg> </span>';
        } else if (m.ext.provider == "youtube") {
          extp = '<span><svg class="nchat_ext" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 71.412065 50"><g transform="scale(0.58823529,0.58823529)"><path d="M 118.9,13.3 C 117.5,8.1 113.4,4 108.2,2.6 98.7,0 60.7,0 60.7,0 60.7,0 22.7,0 13.2,2.5 8.1,3.9 3.9,8.1 2.5,13.3 0,22.8 0,42.5 0,42.5 0,42.5 0,62.3 2.5,71.7 3.9,76.9 8,81 13.2,82.4 22.8,85 60.7,85 60.7,85 c 0,0 38,0 47.5,-2.5 5.2,-1.4 9.3,-5.5 10.7,-10.7 2.5,-9.5 2.5,-29.2 2.5,-29.2 0,0 0.1,-19.8 -2.5,-29.3 z" inkscape:connector-curvature="0" style="fill:#ff0000" /><polygon points="80.2,42.5 48.6,24.3 48.6,60.7 " style="fill:#ffffff" /></g></svg> </span>';
        } else if (m.ext.provider == "twitch") {
           extp = '<span><svg class="nchat_ext" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 2400 2800"><style type="text/css"> .st0{fill:#FFFFFF;} .st1{fill:#9146FF;}</style><g><polygon class="st0" points="2200,1300 1800,1700 1400,1700 1050,2050 1050,1700 600,1700 600,200 2200,200"/><g><g><path class="st1" d="M500,0L0,500v1800h600v500l500-500h400l900-900V0H500z M2200,1300l-400,400h-400l-350,350v-350H600V200h1600V1300z"/><rect x="1700" y="550" class="st1" width="200" height="600"/><rect x="1150" y="550" class="st1" width="200" height="600"/></g></g></g></svg></span>';
        } else {
        }
      } else if (m.f == vx.user.id) {
        m.n = "You";
      }
      if (m.r) {
        let ar = m.r.split("/");
        m.acc = ar[0];
        m.pr = ar[1];
      }

      let is_mod = false;
      m.nn = m.n;
      if (m.ow || m.md) {
        if (!vue.chat_host_logo) { m.nn += String.fromCodePoint(0x2B50); }
        is_mod=true;
      }

      if (m.y) {
        /* x is "about whom" for notes */
        if (m.y.sub == "trans") {
          if (m.y.to) {
            m.t = "Transferred to "+m.y.to;
          } else if (m.y.from) {
            m.t = "Transferred from "+m.y.from;
          }
        } else if (m.y.sub == "note") {
          if (m.y.a == "join") {
            m.t = `User joined the room (${m.y.em})`;
          } else if (m.y.a == "exit") {
            m.t = `User left the room (${m.y.em})`;
          }
        } else if (m.y.sub == "arrival") {
          m.t = `Entered monitored room ${m.y.at}`;
        }
      } else  if (m.x) {
        /* 1-to-1 */
        m.nn = "[ "+m.nn+" ]";
      }

      m.tt = m.t;
      /* Empty question from a broadcast */
      if (m.fc && !m.t) { return; }
      if (!m.f) { return; }
      if (m.t && m.t.indexOf("$join") == 0) {
          m.tt = '<span>Click to open room</span><button class="btn btn-outline-primary btn-join" onclick="chatCallMethod(3)"> JOIN </button>';
      } else if (m.t && m.t.indexOf("$") == 0) {
        return null;
      } else if (m.y) {
          if (m.y.sub == "trans" && m.y.from && m.y.key) {
            m.tt = '<span class="chat-roomtran" froom="'+m.y.from+'" trkey="'+m.y.key+'" trx="'+m.x+'" trep="'+m.ep+'" onclick="chatCallMethod(4,this)">'+m.tt+'</span>';
          }
      } else if (m.t) {
        let mat = m.t.match(/(?:(?:https?|ftp|rtmps?|wss?):\/\/)?[\w/\-?=%.]+\.[\#\:\w/\-?=%.&\+]+/igm);
        if (mat) {
          mat.forEach(function(url) {
            let proto="";
            /* As an extra check, url should have at least 3 of
             *  protocol, dots, slashs so that "That is good.Now how about"
             *  does not match. */
            if (url.split(/[\.\/]/).length < 3) { return; }
            if (url.indexOf("//") == 0) {
               proto = "https:";
            } else if (!url.match(/(https?|ftp|rtmps?|wss?):\/\//)) {
               proto = "https://";
            }
            let link = '<a class="nchat_url" onclick="chatCallMethod(2,this); return false;" href="'+proto+url+'">Link</a>';
            m.tt = m.t.replace(url, link);
          });
        }
        if (m.fc) {
          m.tt = '<span style="margin-right:0.5rem;font-weight:bold;">[Broadcast]</span>'+m.tt;
        }
      }

      let h = "";
      //if (m.r && (!vue.chat_room || vue.chat_room != m.r)) {
      //  vue.chat_room = m.r;
      //  if (m.acc == window.vx.acc) {
      //    h += '<div class="nchat_line" style="color:black;font-weight:400;">@'+m.pr+'</div>';
      //  } else {
      //    h += '<div class="nchat_line" style="color:black;font-weight:400;">@'+m.r+'</div>';
      //  }
      //}

      let str = "";
      let dt = new Date(+m.ep);
      if (!vue.chat_last_dt || dt.getDay() != vue.chat_last_dt.getDay()) {
         str = format(dt,'MM/dd E h:mma');
      } else if (dt.getHours() != vue.chat_last_dt.getHours() ||
                 dt.getMinutes() != vue.chat_last_dt.getMinutes()) {
         str = format(dt,'h:mma');
      }
      vue.chat_last_dt = dt;

      let brk = '<span class="nchat_line_brk nchat_line_main" ephidx="0"></span>';
      if (m.ephidx) { brk = '<span class="nchat_line_brk" ephidx="'+m.ephidx+'">'+m.ephidx+'</span>'; }
      if (vue.chat_host_logo && is_mod && !extp) {
         extp = '<img style="max-width:2rem;max-height:1rem;border-radius:4px;margin-right:0.2rem;"; src="'+vue.chat_host_logo+'"></img>';
      }

      let from_style = "";
      h += '<div class="nchat_line" style="color:#ffffff">';
      h += '<div class="nchat_line_from_outer">'+extp;
      if (m.f) {
        let c = vue.uid2color(m.f);
        from_style += 'border: 1px solid '+c[0]+';';
        from_style += 'background: linear-gradient('+c[1]+', '+c[1]+');'
        h += '<span class="nchat_line_from" uid="'+m.f+'" mod="'+is_mod+'" dname="'+m.n+'" onclick="chatCallMethod(1,this)" style="'+from_style+'">'+m.nn+'</span>';
      }
      h += '</div>'+brk;

      h += '<span class="nchat_line_msg_outer">';
      if (m.y && m.x && m.y.sub) {
          let about_style = "";
          let c = vue.uid2color(m.x);
          about_style += 'border: 1px solid '+c[0]+';';
          about_style += 'background: linear-gradient('+c[1]+', '+c[1]+');'
          h += '<span class="nchat_line_from" uid="'+m.x+'" dname="'+m.xn+'" onclick="chatCallMethod(1,this)" style="'+about_style+'">'+m.xn+'</span>';
      }
      h += '<span class="nchat_line_msg" style="'+from_style+'">'+m.tt+'</span>';
      h += '<span class="nchat_line_tm" style="color:#888888;">'+str+'</span>';
      h += '</span></div>';
      return h;
    },
    wss_msg_to: function(msg) {
      let vue = this;
      if (msg && (msg.data == "denied" || msg.data == "error")) {
        if (vue.chat_tgt && vue.chat_tgt.uid != "PRESENTER") {
          vue.$parent.notification = {alertCountDown: 3,
             alertMessage: "Message failed. "+vue.chat_tgt.dname+" may no longer be in the room."};
        } else {
          vue.$parent.notification = {alertCountDown: 3,
             alertMessage: "Failed to send message"};
        }
        return;
      }
      if (msg && msg.data) {
         if (msg.data.t.indexOf("$kvm") == 0 ||
             msg.data.t.indexOf("+kvm") == 0 || 
             msg.data.t.indexOf("$1on1") == 0 ||
             msg.data.t.indexOf("+1on1") == 0) {
             return;
         }
         if (msg.data.t.indexOf("$alert") == 0) {
             vue.$parent.notification = {alertCountDown: 4,
                alertVariant: "warning",
                alertMessage: msg.data.t.substring(6)};
             return;
         }
      }

      if (!msg.data.fc) {
         if (!msg.data.y || msg.data.y.sub == "note") {
           vue.updateUser({uid: msg.data.f,
                           dname:msg.data.n,
                           from_at:Math.trunc((Date.now()/1000)),
                           blink: (vue.chat_tgt && vue.chat_tgt.uid &&
                                   msg.data.f != vue.chat_tgt.uid)
                           });
        } else if (msg.data.x && msg.data.xn) {
           /* Specific to transfer only */
           vue.updateUser({uid: msg.data.x,
                           dname:msg.data.xn,
                           from_at:Math.trunc((Date.now()/1000)),
                           blink: (vue.chat_tgt && vue.chat_tgt.uid &&
                                   msg.data.x != vue.chat_tgt.uid)
                           });
        }
      }

      let tgt_room = vx.room.main_room;
      if (msg) {
        if (msg.data.ephidx == 0 && msg.data.md) {
          tgt_room = vx.room.name;
        } else if (msg.data.ephidx) {
          tgt_room += "."+msg.data.ephidx;
        }
      }

      let hash = msg.data.r + msg.data.ep;
      vue.chats_hash[hash] = true;
      vue.chats.push(msg.data);

      let x = vue.msg2html(msg.data);
      if (x) {
        let top = 0;
        let bottom_of_screen = 0;
        try {
          top = $("#chat_history").children().last().offset().top;
          bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
        } catch(e) {
        }
        $("#chat_history").append(x);
        if (vue.eph_mode == "open") {
          $(".nchat_line_brk").off("click").on("click", vue.chat_eph_clicked);
        }
        if (top < bottom_of_screen) {
          /* If last message was prevuously in view, scroll 
             to keep last in view */
          vue.scrollIntoView();
        }
      }
    },
    chat_eph_clicked: function(ev) {
      let vue = this;
      if (!ev || !ev.target || !ev.target.attributes) {
        return;
      }
      let ephidx = 0|ev.target.attributes.ephidx.value;
      //console.log("clicked",ephidx,vue.chat_filter_ephidx);
      if (!ephidx || ephidx == vue.chat_filter_ephidx) {
         vue.chat_filter_ephidx = 0;
      } else {
         vue.chat_filter_ephidx = ephidx;
      }
      vx_to_brk_room(vx, ephidx);
      //console.log("now",vue.chat_filter_ephidx);
      /* Render with filter */
      let h = "";
      vue.chat_last_dt = null;
      vue.chats.forEach(function(m) {
        let x = vue.msg2html(m);
        if (x) {
          h += x;
        }
      });
      $("#chat_history").html(h);
      if (vue.eph_mode == "open") {
        $(".nchat_line_brk").off("click").on("click", vue.chat_eph_clicked);
      }
      /* Update highlight */
      vue.highlight_eph_list();
    },
    getchats(direction) {
      let vue = this;
      let msg = {};
      //console.log("DIRECTION:"+direction);
      vue.chat_room = "";
      if (!direction) {
        vue.chats = [];
        vue.chats_hash = {};
        vue.chats_eph_hash = {};
        vue.chat_kind = null;
        vue.chatList_prevref = null;
        vue.chatList_nextref = null;
        if (vue.is_guest) {
          /* Limit to past hour */
          msg.chat_kind = "after_ep";
          msg.chat_arg = (Date.now()/1000) - (1*3600);
        }
      } else if (direction == "older" && vue.chatList_prevref) {
        vue.chat_kind = msg.chat_kind = "before_ref";
        msg.chat_arg = vue.chatList_prevref;
      } else if (direction == "newer" && vue.chatList_nextref) {
        vue.chat_kind = msg.chat_kind = "after_ref";
        msg.chat_arg = vue.chatList_nextref;
      }
      msg.chat_limit = 20;
      window.wss_send(window.vx, "get_my_chat", msg);
    },
    wss_chats: function(msg) {
      let vue = this;
      if (!msg) { return; }
      if (msg.data == "denied" || msg.data == "error") {
        return;
      }
      if (!msg.data.m || msg.data.m.length == 0) {
        if (!vue.chat_ctrl.wmsg) {
          return;
        }
        msg.data.m = [{
          f: "auto",
          n: "",
          t: vue.chat_ctrl.wmsg,
          ow: true,
          ep: Date.now(),
        }];
      }
      if (!vue.chatList_prevref || vue.chat_kind == "before_ref") {
        vue.chatList_prevref = msg.data.tlk;
      }
      if (!vue.chatList_nextref || !vue.chat_kind || vue.chat_kind == "after_ref") {
        vue.chatList_nextref = msg.data.hdk;
      }
      msg.data.m.forEach(function(m) {
        let hash = m.r + m.ep;
        if (vue.chats_hash[hash]) {
          return;
        }
        vue.chats_hash[hash] = true;
        vue.chats.push(m);
      });
      vue.chats = vue.chats.sort(function(a,b) {
        return a.ep - b.ep;
      });
      if (vue.chats[0]) {
         let dt = new Date(+vue.chats[0].ep);
         vue.chat_older_str = format(dt,'MM/dd E h:mma');
      }

      let h = "";
      vue.chat_last_dt = null;
      vue.chats.forEach(function(m) {
        let x = vue.msg2html(m);
        if (x) {
          h += x;
        }
      });

      $("#chat_history").html(h);
      if (vue.eph_mode == "open") {
        $(".nchat_line_brk").off("click").on("click", vue.chat_eph_clicked);
      }
      vue.scrollIntoView();
    },
    refresh_chat_view: function() {
      let vue = this;
      let h = "";
      vue.chat_last_dt = null;
      vue.chats.forEach(function(m) {
        let x = vue.msg2html(m);
        if (x) {
          h += x;
        }
      });
      if (vue.chat_tgt && vue.chat_tgt.uid)  {
        $("#rcid"+vue.chat_tgt.uid).attr("blink","false");
      }
      $("#chat_history").html(h);
    },
    emit_help: function() {
      let vue = this;
      let cmds = [];
      if (vx.room.is_mod) {
        cmds=[
          ["$alert [msg]","Send message as a banner alert to everone in the room"],
          ["$join","Post a 'Join' button that opens the meeting room"],
        ];
      }
      let h = "";
      cmds.forEach(function(x) {
        h += '<div class="nchat_line">';
        h += '<div class="nchat_line_from_outer" style="color:black;font-size:0.9rem;font-weight:bold;">';
        h += x[0];
        h += '</div>';
        h += '<span class="nchat_line_msg_outer">';
        h += '<span class="nchat_line_msg" style="color:black;font-size:0.9rem;">'+x[1]+'</span>';
        h += '</span>';
        h += '</div>';
      });
      $("#chat_history").append(h);
      vue.scrollIntoView();
    },
    do_noaccess: function(opt) {
      let vue = this;
      vue.noaccess = true;
      if (!vue.$refs || !vue.$refs.noaccess) { return; }
      opt = opt || {};
      vue.$refs.noaccess.trigger_noaccess(opt);
      return;
    },
    do_access: function() {
      let vue = this;
      vue.noaccess = false;
      if (!vue.$refs || !vue.$refs.noaccess) { return; }
      vue.$refs.noaccess.close();
    },
    chat_submit: function(ev) {
      let vue = this;
      //console.log("chat_submit:"+vue.chat_msg); return;
      let txt = ""+vue.chat_msg;
      let eph = (txt.indexOf("$") == 0);
      vue.$refs.chat_input_box.reset();
      vue.updateChatInputState();
      if (!txt) { return; }

      /* to.room = true : broadcast to entire room
       * to.uid = <uid> : send to specific user
       */
      let msg = {msg:txt, to:{}, eph:eph};
      if (vue.mode == "note") {
        if (!vx.room.is_mod) { return; }
        if (eph) {
          vue.$parent.notification = {
            alertCountDown:3,
            alertMessage:"Commands cannot be used in a note."
          };
          return;
        }
        msg.y = {sub:"note"};
        msg.to.uid = vue.chat_tgt.uid;
        msg.to.dname = vue.chat_tgt.dname;
      } else {
        if (txt.indexOf("$kvm") == 0) {
        } else if (txt.indexOf("$help") == 0) {
          vue.emit_help();
          return;
        } else if (vue.chat_tgt && vue.chat_tgt.uid == "PRESENTER") {
          msg.to.room = false;
        } else if (!vue.chat_tgt) {
          if ((vue.chat_ctrl.mode == "any") || vx.room.is_mod) {
            /* User is capable of 1-to-1 and broadcasting */
            msg.to.room = true;
          } else {
            /* User only allowed to send to all presenters/moderators.
             * Command is the same but worth noting difference */
            msg.to.room = false;
          }
        } else {
          /* A simple 1-to-1 message */
          msg.to.uid = vue.chat_tgt.uid;
          vue.updateUser({uid: vue.chat_tgt.uid,
                          dname: vue.chat_tgt.dname,
                          to_at:Math.trunc((Date.now()/1000))
                         });
        }
      }
      wss_send(vx, "msg_to", msg);
    },
    chat_msg_keyup: function(event) {
      let vue = this;
      //console.log("chat_keyup:",event); return;
      if (event.keyCode == 13) {
      } else if (event.key === ':') {
        let msg = ""+vue.chat_msg;
        msg = msg.replace(":hamburger:",String.fromCodePoint(0x1F354));
        msg = msg.replace(":check:",String.fromCodePoint(0x2714));
        msg = msg.replace(":money:",String.fromCodePoint(0x1F4B0));
        msg = msg.replace(":rocket:",String.fromCodePoint(0x1F680));
        msg = msg.replace(":ex:",String.fromCodePoint(0x2757));
        msg = msg.replace(":happy:",String.fromCodePoint(0x1F603));
        msg = msg.replace(":zap:",String.fromCodePoint(0x26A1));
        vue.chat_msg = msg;
      }
    },
    wss_list_user: function(msg) {
      let vue = this;
      clearInterval(vue.user_tid);
      if (msg.data.uid == vx.user.id) {
        /* FOR SELF */
        if (msg.data.roles) {
          let r = msg.data.roles;
          /* These roles are specific to this room */
          vx.room.is_mod = r.is_mod;
          vx.room.is_owner = r.is_owner;
          vx.room.can_join = r.can_join;
          vx.room.can_view = r.can_view;
          if (vx.room.is_mod) {
            vue.updatePresentUsers();
            vue.user_tid = window.setInterval(vue.updatePresentUsers, 20000);
          }
        }
        if (msg.data.ephidx && msg.data.ephidx != vue.chat_filter_ephidx) {
           vue.setup_room(vx, vx.room.acc, (vx.room.main_room+"."+msg.data.ephidx));
           return;
        }
      }
      vue.updateChatInputState();
    },
    wss_room: function(msg) {
      if (msg.data.k && msg.data.k == "breakout") {
        let ephidx = 0|msg.data.n;
        if (!ephidx && vx.room.ephidx) {
           this.setup_room(vx, vx.room.acc, vx.room.main_room);
        } else if (ephidx != vx.room.ephidx) {
           this.setup_room(vx, vx.room.acc, (vx.room.main_room+"."+ephidx));
        }
      }
    },
    wss_room_ctrl: function(msg) {
      let vue = this;
      let fetch = false;
      vue.chat_ctrl = msg.data.chat || {};

      if (msg.data.error == "error") {
        msg.data.src = "room_ctrl";
        msg.data.txt = "Something went wrong.";
        vue.do_noaccess(msg.data);
        return;
      }
      if (msg.data.error == "denied") {
        msg.data.src = "room_ctrl";
        msg.data.check_meet = true;
        if (vx.room.auth_error) {
          msg.data.txt = vx.room.auth_error;
        }
        if (vx.room.auth_restart) {
          msg.data.restart = vx.room.auth_restart;
        }
        vue.do_noaccess(msg.data);
        return;
      }
      vue.do_access();

      if (msg.data.rlogosm && msg.data.rlogosm != "-") {
        vue.chat_host_logo = msg.data.rlogosm || "";
      }
      vue.eph = msg.data.eph || 0;
      if (msg.data.event) {
         vue.chat_dname = msg.data.dname;
      }
      if (!vue.eph_mode || vue.eph_mode != msg.data.eph_mode) {
        vue.eph_mode = msg.data.eph_mode || "open";
        fetch = true;
      }
      if (vue.chat_filter_ephidx > vue.eph) {
        vue.setup_room(vx, vx.room.acc, vx.room.main_room);
        return;
      }
      if (fetch) {
        vue.getchats();
      }
      vue.switch2Hosts();
      vue.updateChatInputState();
      vue.render_eph_list();
    },
    render_eph_list: function() {
      let vue = this;
      let h = "";
      if (vue.eph_mode == "open") {
        for (let i=0; i<=vue.eph; i++) {
          h += '<span class="nchat_line_brk nchat_line_sel" ephidx="'+i+'">'+((i==0)?"M":i)+'</span>';
        }
        $("#ephselect").html(h);
        $(".nchat_line_brk").off("click").on("click", vue.chat_eph_clicked);
      } else {
          let i = +vue.chat_filter_ephidx;
          h += '<span class="nchat_line_brk nchat_line_sel" ephidx="'+i+'">'+((i==0)?"M":i)+'</span>';
        $("#ephselect").html(h);
      }
      vue.highlight_eph_list();
    },
    highlight_eph_list: function() {
      let vue = this;
      $('.nchat_line_sel').attr("sel","false");
      $('.nchat_line_sel[ephidx="'+vue.chat_filter_ephidx+'"]').attr("sel","true");
    },
    updateChatInputState: function() {
      let vue = this;
      vue.chat_tgt_msg = "";
      vue.transfer_allowed = false;
      vue.note_allowed = false;
      if (!vx.room.can_view) {
        vue.chat_tgt_msg = "You do not have permission to view this room. Only your old chats will show, if any.";
        vue.chat_disabled = true;
      } else if (vue.chat_ctrl.mode == "disabled") {
        vue.chat_tgt_msg = "Chat for this room is currently disabled.";
        vue.chat_disabled = true;
      } else if (!vx.room.can_join) {
        vue.chat_tgt_msg = "You can only read.";
        vue.chat_disabled = true;
      } else if (vue.chat_tgt && vue.chat_tgt.uid == "PRESENTER") {
        if (vue.chat_ctrl.mode == "limited2") {
          /* Moderators are only option */
          vue.tgt_text = "";
        } else {
          vue.tgt_text = "Only Moderators";
        }
        vue.chat_disabled = false;
        if (vue.mode == "transfer" || vue.mode == "note") {
          vue.mode = "msg";
        }
      } else if (!vue.chat_tgt) {
        vue.chat_disabled = false;
        if (vue.chat_ctrl.mode == "any" || vx.room.is_mod) {
          vue.tgt_text = "Everyone";
        } else {
          vue.tgt_text = "Only Moderators";
        }
        if (vue.mode == "transfer" || vue.mode == "note") {
          vue.mode = "msg";
        }
      } else {
        vue.chat_disabled = false;
        vue.tgt_text = vue.chat_tgt.dname;
        vue.transfer_allowed = !!vx.room.is_mod;
        vue.note_allowed = !!vx.room.is_mod;
      }

      if (vue.chat_disabled) {
         vue.show_2pres = false;
         vue.show_2all = false;
      } else if (vue.chat_ctrl.mode == "any" || vx.room.is_mod) {
         vue.show_2pres = true;
         vue.show_2all = true;
      } else {
         vue.show_2pres = true;
         vue.show_2all = false;
      }
      vue.renderRecents();
      vue.changeMode();
    },

    /****************************************************************************/

    queryUsers: function(cb) {
        window.wss_send_cb(window.vx, "list_room", {
           all:true,
           filt:{kind:"view"},
           limit:10
        }, function(msg) {
           /* Don't call-back on failure since
              we have no useful info */
           if (!msg) { return; }
           let res = msg.data || [];
           res.pop();
           cb && cb(res);
        });
    },
    updatePresentUsers: function() {
      let vue = this;
      vue.queryUsers(function(users) {
         let now = Math.trunc(Date.now()/1000);
         Object.keys(vue.users).forEach(function(uid) {
           vue.users[uid].present_at = 0;
         });
         users.forEach(function(u) {
            if (u.roles) {
              if (u.roles.is_mod) { return; }
            }
            let opt = {};
            opt.dname = u.dname;
            opt.uid = u.uid;
            opt.present_at = now;
            vue.updateUser(opt);
         });
         /* This empty call is to make sure we trigger a
            buildRecents when the present users goes to zero */
         vue.updateUser();
      });
    },
    updateUser: function(opt) {
      let vue = this;
      //console.log("RECENT updateUser",JSON.stringify(opt));
      if (opt && opt.uid && opt.uid != "0") {
        if (opt.uid == vx.user.id) { return; }
        let u = vue.users[opt.uid] || {};
        u.dname = opt.dname || u.dname;
        u.uid = opt.uid;
        u.present_at = opt.present_at || u.present_at || 0;
        u.from_at = opt.from_at || u.from_at || 0;
        u.to_at = opt.to_at || u.to_at || 0;
        if (opt.click) { u.click = opt.click; }
        if (opt.blink !== undefined) {
          u.blink = opt.blink;
        }
        if (opt.transfer) {
          u.present_at = 0;
          u.from_at = 0;
          u.to_at = 0;
          delete u.click;
        }
        vue.users[opt.uid] = u;
      }
      if (!vue.build_tid) {
         vue.build_tid = setTimeout(vue.buildRecents, 500);
      }
    },
    buildRecents: function() {
      let vue = this;
      let list = [];
      let del=[];
      let now = Math.trunc(Date.now()/1000);
      Object.keys(vue.users).forEach(function(uid) {
         let u = vue.users[uid];
         /* Still present? */
         if (u.click || u.present_at) { return; }
         /* Recently messaged to or messaged from */
         /*if ((now - u.to_at) < 59) { return; }*/
         if ((now - u.from_at) < 59) { return; }
         del.push(uid);
      });
      del.forEach(function(uid) {
         delete vue.users[uid];
      });

      clearInterval(vue.build_tid);
      delete vue.build_tid;
      Object.keys(vue.users).forEach(function(uid) {
        let u = vue.users[uid];
        if (!vx.room.is_mod && !u.click) { return; }
        list.push(vue.users[uid]);
      });

      list = list.sort(function(a,b) {
        if (a.to_at && a.to_at > b.to_at) {
           return -1; //a
        }
        if (b.to_at && b.to_at > a.to_at) {
           return 1;  //b
        }
 
        if (a.from_at && a.from_at > b.from_at) {
           return -1; //a
        }
        if (b.from_at && b.from_at > a.from_at) {
           return 1;  //b
        }

        // Largest (i.e. most recent) first
        return (b.present_at - a.present_at);        
      });
      //console.log("RECENT buildRecents",JSON.stringify(list));
      vue.chat_recent = list.slice(0,10);
      vue.renderRecents();
    },

    switch2Hosts: function() {
      let vue = this;
      vue.chat_tgt = {uid: "PRESENTER"};
      vue.updateChatInputState();
      vue.refresh_chat_view();
    },
    switch2All: function() {
      let vue = this;
      vue.chat_tgt = null;
      vue.updateChatInputState();
      vue.refresh_chat_view();
    },
    switch2User: function(uid, dname) {
      let vue = this;
      vue.chat_tgt = {uid: uid, dname: dname};
      vue.updateUser({uid: uid, dname: dname, blink:false, click:true});
      vue.updateChatInputState();
      vue.refresh_chat_view();
    },
    switch2UserTap: function(el) {
      let vue = this;
      let attr = el.attributes;
      let uid = attr.uid && attr.uid.value;
      let dname = attr.dname && attr.dname.value;
      let is_mod = attr.mod && attr.mod.value == "true";
      if (!uid || uid == "anon" || uid == "0") { return; }
      /* Clear out 'click' for everyone */
      Object.keys(vue.users).forEach(function(uid) {
         delete vue.users[uid].click;
      });
      if (uid == "PRESENTER") {
         vue.switch2Hosts();
      } else if (uid == "ALL") {
         vue.switch2All();
      } else if (uid != vx.user.id && (!vue.chat_tgt || vue.chat_tgt.uid != uid)) {
         if (vue.chat_ctrl.mode == "limited2" && !vx.room.is_mod && !is_mod) {
            return;
         }
         vue.switch2User(uid, dname);
      }
      vue.scrollIntoView();
    },

    renderRecents: function() {
      let vue = this;
      if (vue.chat_disabled) {
        $("#chat_recent").empty();
        return;
      }
      let h = "";
      let cls = '';
      if (vue.show_2all) {
        cls = 'nchat_line_from';        
        if (!vue.chat_tgt || !vue.chat_tgt.uid) {
          cls += " nchat_selected";
        }
        h += '<span class="nchat_line_from_outer" style="margin-right:.2rem;"><span class="'+cls+'" uid="ALL" onclick="chatCallMethod(1,this)" style="background:rgba(0,0,250,0.4)">All</span></span>';
      }
      if (vue.show_2pres) {
        cls = 'nchat_line_from';
        if (vue.chat_tgt && vue.chat_tgt.uid == "PRESENTER") {
          cls += " nchat_selected";
        }
        if (!vue.chat_host_logo) {
          h += '<span class="nchat_line_from_outer" style="margin-right:.2rem;"><span class="'+cls+'" uid="PRESENTER" onclick="chatCallMethod(1,this)" style="background:rgba(0,0,250,0.4)">Host/Mod</span>';
        } else {
          h += '<span class="nchat_line_from_outer" style="margin-right:.2rem;"><span class="'+cls+'" uid="PRESENTER" onclick="chatCallMethod(1,this)"><img style="max-width:5rem;max-height:1rem;border-radius:4px;" src="'+vue.chat_host_logo+'"></img></span>';
        }
      }
      vue.chat_recent.forEach(function(m) {
        let style = "";
        let blink = "";
        let c = vue.uid2color(m.uid);
        cls = 'nchat_line_from';
        if (vue.chat_tgt && vue.chat_tgt.uid == m.uid) {
          cls += " nchat_selected";
        }
        if (!m.from_at && !m.to_at && !m.click) {
          style += "opacity:0.5;"
        }
        if (m.blink) { blink='blink="true"'; }
        style += 'background: linear-gradient('+c[1]+', '+c[1]+');'
        h += '<span class="nchat_line_from_outer" style="margin-right:.2rem;"><span class="'+cls+'" id="rcid'+m.uid+'" uid="'+m.uid+'" mod="'+m.is_mod+'" dname="'+m.dname+'" '+blink+' onclick="chatCallMethod(1,this)" style="'+style+'">'+m.dname+'</span></span>';
      });
      $("#chat_recent").html(h);
    },

    /*******************************************************************/
    openRoom: function() {
      this.$parent.openRoom(vx.room.acc,vx.room.name);
    },
    chatURLOpen: function(el) {
      let vue = this;
      let url = el.href;
      if (url) {
         if (vue.$parent.inIframe) {
           /* Must open from top to preserve proper "back" or "done" URL */
           window.top.vx.open_native_url(url);
         } else {
           window.vx.open_native_url(url);
         }
      }
      return false;
    },
    wss_poll: function(msg) {
      let vue = this;
      //console.log(msg);
      if (!msg.data) { return; }
      if (msg.data.list) {
         let plhist = getLocal("plhist",true) || [];
         let hist = {};
         plhist.forEach(function(h) {
           if (h.rm != vx.room.name) { return; }
           hist[h.id] = {rev:h.rev,sel:h.sel};
         });
         vue.pollQuests = [];
         msg.data.qs.forEach(function(q) {
           if (!q.active) { return; }
           let h = hist[q.id] || {};
           vue.pollQuests.push({
             id: q.id,
             q: q.q,
             a: q.a,
             rev: q.rev,
             disabled: (q.rev == h.rev),
             selected: h.sel,
           });
         });
       //console.log(JSON.stringify(vue.pollQuests));
      }
    },   
    refreshPollList: function() {
      let vue = this;
      vue.pollQuests = [];
      window.wss_send(window.vx, "poll", {cmd:"list"});
    },
    do_attach: function() {
      let vue = this;
      if (vue.mode != "attach") {
        vue.changeMode("attach");
      } else {
        vue.changeMode("msg");
      }
      vue.attach_url = "";
      vue.scrollIntoView();
    },
    attach_ready: function(url,mime,ftype) {
      let vue = this;
      vue.changeMode("msg");
      if (!vue.chat_msg) {
         vue.chat_msg = `${ftype} attachment: `+url;
      } else {
         vue.chat_msg += " "+url;
      }
      vue.chat_submit();
      vue.attach_url = "";
    },
    pollClick: function() {
      let vue = this;
      vue.refreshPollList();
    },
    pollVote: function() {
      let vue = this;
      let plhist = getLocal("plhist",true) || [];
      if (plhist.length > 50) { plhist = []; }
      vue.pollQuests.forEach(function(q) {
        if (q.selected && !q.disabled) {
           window.wss_send(window.vx, "poll", {cmd:"vote",
              q:{id: q.id, aid: q.selected},
           });
           plhist.push({rm:vx.room.name,id:q.id,rev:q.rev,sel:q.selected});
           q.disabled = true;
        }
      });
      setLocal("plhist",JSON.stringify(plhist));
    },
    do_transfer: function() {
      let vue = this;
      if (vue.mode != "transfer") {
        vue.changeMode("transfer");
      } else {
        vue.changeMode("msg");
      }
      vue.scrollIntoView();
    },
    do_note: function() {
      let vue = this;
      if (vue.mode != "note") {
        vue.changeMode("note");
      } else {
        vue.changeMode("msg");
      }
      vue.scrollIntoView();
    },
    transfer_room: function(opt) {
      let vue = this;
      //console.log("room_transfer",JSON.stringify(opt));
      if (!vue.chat_tgt.uid) { return; }
      wss_send_cb(vx, "transfer_room", {
        tgt_uid: vue.chat_tgt.uid,
        to_room: opt.acc+"/"+opt.room,
        force: false,
      }, function(msg) {
         if (!msg || !msg.data || msg.data.error || msg.data.rv == "closed") {
           let e = "Unable to transfer user.";
           if (msg.data.rv == "closed") {
             e += `Room ${opt.room} is not open.`;
           } else if (msg && msg.data && msg.data.error) {
             if (msg.data.error == "not found") {
               e += "The user is no longer present.";
             } else {
               e += " ["+msg.data.error+"]";
             }
           }
           vue.$parent.notification = {alertCountDown:3,alertMessage:e};
         } else {
           vue.changeMode("msg");
           vue.updateUser({uid: vue.chat_tgt.uid, transfer:true});
         }
      });
    },
    do_search: function(opt) {
      //console.log("do_search",JSON.stringify(opt));
    },
    scrollIntoView: function() {
       let vue = this;
       clearInterval(vue.tid_scroll);
       vue.tid_scroll = setTimeout(function() {
         //let scrollingElement = (document.scrollingElement || document.body);
         //scrollingElement.scrollTop = scrollingElement.scrollHeight;
         if (vue.$refs.chat_input_box) {
            vue.$refs.chat_input_box.scrollIntoView();
         }
       }, 250);
    },
    doHide: function(c) {
     if (!c) { return; }
     for (let i=0; i<c.length; ++i) {
       c[i].style.display = "none";
     }
    },
    tchatTap: function(el) {
      let vue = this;
      let attr = el.attributes;
      let tran = {};
      tran.room = attr.froom && attr.froom.value;
      tran.x = attr.trx && attr.trx.value;
      tran.ep = attr.trep && attr.trep.value;
      tran.key = attr.trkey && attr.trkey.value;
      tran.limit = 40;
      wss_send_cb(vx, "get_tchats", {
        tran: tran,
      }, function(msg) {
        if (!msg || !msg.data || !msg.data.m) { return; }
        let h = "";
        h += "<span>"+tran.room+"</span>";
        msg.data.m.forEach(function(m) {
          h += vue.msg2html(m);
        });
        let p3 = el.parentNode.parentNode.parentNode;
        vue.doHide(p3.getElementsByClassName("nchat_line_from_outer"));
        vue.doHide(p3.getElementsByClassName("nchat_line_from"));
        vue.doHide(p3.getElementsByClassName("nchat_line_tm"));
        el.parentNode.style.width = "100%";
        el.parentNode.style.background = "initial";
        el.innerHTML = h;
        el.onclick = null;
        el.classList.remove("chat-roomtran");
      });
    },
    chatCallMethod: function(fn,a,b) {
      let vue = this;
      switch(fn) {
      case 1:
      case "switchuser":
         vue.switch2UserTap(a);
         return;
      case 2:
      case "openurl":
         vue.chatURLOpen(a);
         return;
      case 3:
      case "openroom":
         vue.openRoom();
         return;
      case 4:
      case "tchat":
         vue.tchatTap(a);
         return;
      }
    }
  },
  computed: {
  },
  beforeDestroy() {
    let vue = this;
    window.wss_clr_routes(window.vx,"chat");
    clearInterval(vue.user_tid);
    clearInterval(vue.build_tid);
    clearInterval(vue.chat_tid);
    clearInterval(vue.tid_scroll);
    delete window.chatCallMethod;
    vxslog({p:"chat",a:"leave"});
  }
};
</script>

<style lang="scss">
.container {
  max-width: 760px;
}

.nchat_line {
  display: flex;
  flex-direction: row;
  line-height:1.1rem;
  padding: 2px 0;
}
.nchat_line_from_outer {
  flex: 2 0 10px;
  text-align:right;
}

.nchat_line_from[blink="true"] {
   animation: blink-animation 1s step-start 0s infinite;
}
@keyframes blink-animation {
  0% {
    color: black;
  }
  50% {
    color: #f08060;
  }
}

.nchat_line_from {
  border-radius:10px;
  padding: 0 5px;
  display:inline-block;
  pointer-events: all;
  cursor: pointer;
  font-size: .9rem;
  color: black;
  border: 1px solid #808080;
}
.nchat_line_msg_outer {
  padding: 0 0 0 15px;
  flex: 7 0 10px;
  text-align:left;
}
.nchat_line_msg {
  border-radius:10px;
  padding: 0 10px;
  display: inline-block;
  pointer-events: visible;
  cursor: default;
  font-size: .9rem;
  color: black;
}
.nchat_line_tm {
  font-size:.75rem;
  padding-left:0.5vw;
}
.nchat_url {
  overflow-wrap:anywhere;
/*
  border-radius: 4px; 
  padding: 0 4px;
*/
  font-size: 0.8rem;
}
.nchat_line_brk {
  flex: 0 0 1rem;
  color:black;
  background: #c0c000;
  text-align:center;
  border-radius: 50%;
  font-size: .75rem;
  line-height: 1.2rem;
}
.nchat_line_main {
  background: transparent;
}
.nchat_line_sel {
  display:inline-block;
  width:1rem;
}
.nchat_line_sel[sel="true"] {
  background-color:red;
}
.nchat_ext {
  width: 0.9rem;
  height: 0.9rem;
}
.nchat_selected {
  box-shadow: 0 0 4px #b09000, 0 0 10px black;
  border: 1px solid black;
}

.chat_btn_mat {
  font-family: 'Material Icons';
  padding:0 0.3rem;
  margin-bottom:0;
  border:none;
}

.chat_btn_attach {
  color: blue;
  font-size: 1.4rem;
  padding:0;
}
.chat_btn_transfer {
  font-size: 0.9rem;
  font-weight: bold;
  border: none;
  padding: 0 0.5rem;
}
.chat_btn_note {
  font-size: 0.9rem;
  font-weight: bold;
  border: none;
  padding: 0 0.5rem;
}
.chat_btn_mode, .chat_btn_mode:focus {
  color: blue;
  line-height: 1.8rem;
  background-color: transparent;
  margin: 0;
}
.chat_btn_mode[modeon="true"] {
  background-color: #e0c060;
}

.btn-join {
 font-size: 0.8rem;
 font-weight: bold;
 margin: 0;
 border: none;
 padding: 0 0.5rem;
}

.chat-roomtran {
 position:relative;
 color:blue;
 cursor: pointer;
}
.chat-roomtran:hover:after {
 position:absolute;
 content: "CLICK TO EXPAND";
 color: black;
 font-size:0.6rem;
 line-height: 0.6rem;
 background-color: white;
 border: 1px solid #808080;
 border-radius: 0.5rem;
 padding: 0 0.2rem;
 right: 1rem;
 bottom: 0.8rem;
}

</style>
